import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FiltrarProdutosService {
  public filtro$: BehaviorSubject<string> = new BehaviorSubject('');
}
